<template>
  <div class="animated fadeIn fadeOut">
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>Log Detail({{model.cmd}})</strong>
            <span class="float-right">Date : {{model.created_at | datetime}}</span>
          </div>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <label for="ph_title" v-b-tooltip.hover title="Title">Title</label><br>
                <label for="ph_title" v-if="model && model.title">{{model.title}}</label>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="ph_category" v-b-tooltip.hover title="Specifies the mail template classification">LEVEL</label><br>
                <v-select v-model="model.level" :options="codes.MAIL_LEVEL" label="name" ></v-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label for="ph_target" v-b-tooltip.hover title="Defines who uses mail templates">Target</label><br>
                <b-form-checkbox-group
                  v-model="model.target_list"
                  :options="codes.MAIL_TARGET"
                ></b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="2">
              <b-form-group>
                <label for="ph_partner" v-b-tooltip.hover title="The partner's information using this.">Partner</label><br>
                <label for="ph_partner" v-if="model && model.id &&  model.partner">{{model.partner && model.partner.username}}</label>
                <b-button v-else-if="!syncPartner && !lock" size="sm" variant="warning" @click="chainPartner = true">
                  {{model.partner ? 'Change' : 'Connect'}} Partner
                </b-button>
                <span v-else>{{parnter_name}}</span>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <label for="ph_description" v-b-tooltip.hover title="you can write some description here!">Description</label><br>
              <b-input v-model="model.description"></b-input>
            </b-col>
            <!-- <b-col md="2" v-if="auth && auth.profile && auth.profile.permissions == 'Owner'">
              <b-form-group>
                <label for="ph_cmd" v-b-tooltip.hover title="recommend this text can change who only admin on site">System Code</label><br>
                <b-input :disabled="model && model.id ? true : false" v-model="model.cmd"></b-input>
              </b-form-group>
            </b-col> -->
            <b-col md="4">
              <label for="ph_partner" v-b-tooltip.hover title="The partner's information using this.">* More option</label><br>
              <b-button style="display: inline-block; width: 45%;" size="sm" block variant="outline-info" :disabled="!(model && model.id)" @click="sample_build"> Send Sample </b-button>
              <b-button style="display: inline-block; width: 45%;" size="sm" variant="danger" @click="confirm_remove = true" :disabled="!(model && model.id)"> Delete </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="6">
        <b-card class="text-center">
          <b-button size="sm" style="width: 48%; display: inline-block;" variant="warning" @click="() => { model && model.id ? confirm_update = true : save() }"> Save </b-button>
          <b-button size="sm" style="width: 48%; display: inline-block;" variant="success" @click="reset" :disabled="!(model && model.id)"> Reset </b-button>
          <hr>
          <b-input :state="model.title != null && model.title != '' ? true : false" class="" v-model="model.title"></b-input>
          <hr>
          <codemirror style="text-align: left;" ref="CodeMirror" v-model="model.content" :options="cmOptions"/>
        </b-card>
      </b-col>
      <b-col lg="12" xl="6">
        <b-card>
          <b-button size="sm" class="w-100" variant="primary" @click="list"> List </b-button>
          <hr>
          Title : {{model.title}}
          <hr>
          <!-- <pre v-if="reload" v-html="model.content" style="background-color:#f5f5f5; border:1px solid #ccc; padding:10px; border-radius: 5px;" class="w-100 h-100 d-inline-block"></pre> -->
          <samp v-html="model.content" style="background-color:#f5f5f5; border:1px solid #ccc; padding:10px; border-radius: 5px; min-height: 1000px;" class="w-100 d-inline-block">
          </samp>
        </b-card>
      </b-col>
    </b-row>
    <!-- start modal area -->
    <b-modal title="Content Remove"  class="modal-danger" v-model="confirm_remove" @ok="remove" ok-variant="danger">
      Are you sure you want to delete the data?
    </b-modal>
    <b-modal title="Content Update"  class="modal-primary" v-model="confirm_update" @ok="save" ok-variant="primary">
      Are you sure you want to update the data?
    </b-modal>
    <b-modal size="xl" title="Find and select Partner"  header-bg-variant="info" v-model="chainPartner" @ok="chainPartner = false" ok-variant="info">
      <Partner-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setPartner"></Partner-List>
    </b-modal>
    <b-modal size="ml" title="Set Sample Data"  class="modal-success" v-model="confirm_sample" @ok="send_sample" ok-variant="info" hide-footer>
      <table class="w-100 text-center">
        <thead>
          <tr>
            <th>key</th>
            <th>value</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="key, index in Object.keys(sample_model)" v-bind:key="index">
            <td>{{key}}</td>
            <td>

              <b-input v-if="key.indexOf('_list') > -1" v-model="sample_model[key][0]"></b-input>
              <b-input v-else v-model="sample_model[key]"></b-input>
            </td>
          </tr>
        </tbody>
      </table>
      <hr>
      <b-button size="sm" class="m-1" block variant="warning" @click="send_sample"> Send Sample to me </b-button>
      <b-button size="sm" class="m-1" block variant="info" @click="confirm_sample = false"> Cancel </b-button>
    </b-modal>
  </div>
</template>

<script>
import PartnerList from '../../Management/partner/Partner.List';
import { VueEditor } from 'vue2-editor'
import { Api , auth} from '@/service';
import codes from '@/codes';
import vSelect from 'vue-select';
// import CodeEditor from 'simple-code-editor';
import { codemirror } from 'vue-codemirror'
import Mirror from './Mirror.vue'
// import { javascript } from '@codemirror/lang-javascript'
// import { oneDark } from '@codemirror/theme-one-dark'

import dedent from 'dedent'
// require styles
import 'codemirror/lib/codemirror.css'
// theme css
import 'codemirror/theme/base16-dark.css'

// language
import 'codemirror/mode/vue/vue.js'

// highlightSelectionMatches
import 'codemirror/addon/scroll/annotatescrollbar.js'
import 'codemirror/addon/search/matchesonscrollbar.js'
import 'codemirror/addon/search/searchcursor.js'
import 'codemirror/addon/search/match-highlighter.js'
// keyMap
import 'codemirror/mode/clike/clike.js'
import 'codemirror/addon/edit/matchbrackets.js'
import 'codemirror/addon/comment/comment.js'
import 'codemirror/addon/dialog/dialog.js'
import 'codemirror/addon/dialog/dialog.css'
import 'codemirror/addon/search/searchcursor.js'
import 'codemirror/addon/search/search.js'
import 'codemirror/keymap/sublime.js'
// foldGutter
import 'codemirror/addon/fold/foldgutter.css'
import 'codemirror/addon/fold/brace-fold.js'
import 'codemirror/addon/fold/comment-fold.js'
import 'codemirror/addon/fold/foldcode.js'
import 'codemirror/addon/fold/foldgutter.js'
import 'codemirror/addon/fold/indent-fold.js'
import 'codemirror/addon/fold/markdown-fold.js'
import 'codemirror/addon/fold/xml-fold.js'

export default {
  computed: {
    codemirror() { return this.$refs.CodeMirror }
  },
  components: { vSelect, VueEditor, PartnerList, codemirror, Mirror },
  data : () => {
    return {
      auth,
      lock : false,
      model : {},
      parnter_name : '',
      codes,
      reload : true,
      init : '',
      confirm_remove : false,
      confirm_update : false,
      chainPartner : false,
      syncPartner : false,
      confirm_sample : false,
      sample_model : {

      },
      // codemirror options
      cmOptions: {
        tabSize: 4,
        mode: 'text/html',
        theme: 'base16-dark',
        lineNumbers: true,
        line: true,
      }
    }
  },
  methods: {
    sample_build() {
      this.sample_model = Object.assign({})
      const matches = (this.model.content || '').matchAll(/[M|m]odel.(.\w{0,})/g);

      for (const match of matches) {
        // let tmp = {}
        let v = ''
        let key = match[1]
        if(key == 'time') {
          continue
        }
        else if(key.indexOf('_list') > -1) {
          // 변수 어레이 처리
          this.sample_model[key] = ['test value auto setting']
        } else {
          if(key == 'address') { v = '서울특별시 금천구 가산동 벚꽃로 234' }
          if(key == 'slogan') { v = 'F1-UWSS' }
          if(key == 'domain') { v = location.hostname }
          if(key == 'company') { v = 'f1security' }

          this.sample_model[match[1]] = v
        }

        console.log(match[0], match[1], match.index);
      }

      this.confirm_sample = true;
    },
    async send_sample() {
      try {
        let rs = await Api.Manager_Call('mail', 'sample', { model : this.sample_model, cmd : this.model.cmd });
        if(!rs.error) {
          this.$toastr.s('Sent', this.$route.name);
          // this.list();
          this.confirm_sample = false
        } else {
          this.$toastr.e('Sent', "failed");
        }
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText) , this.list() }
    },
    setPartner(item) {
      this.model.partner = item;
      this.chainPartner = false;
      this.model.partner_id = item.id;
      this.syncPartner = true;
      this.parnter_name = item.username;
      console.log(this.model.partner_id)
      this.$toastr.i("please apply your change", "done")
    },
    refresh(id) {
      this.$router.push({ name: 'mail', params : { id : id ? id : this.model.id } });
    },
    reset() {
      this.model.content = this.init;
    },
    change(content) {
      console.log("changed")
      this.model = Object.assign({}, this.model, { content : content })
    },
    list() { this.$router.push({ name: 'mail'}); this.$emit('refresh'); },
    async get({ id } = this.$route.params) {
      if(id === 'add') { this.add = true; this.lock = false; return; }
      try {
        let rs = await Api.Manager_Call('mail', 'detail', { id : id });
        this.model = Object.assign({ group: {} }, this.model, rs.body)

        this.init = this.model.content;

        this.model.target_list = this.model.target

      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText) , this.list() }
    },
    async remove() {
      try {
        let rs = await Api.Manager_Call('mail', 'remove', { id : this.model.id });
        if(!rs.error) {
          this.$toastr.s('removed', this.$route.name);
          this.list();
        } else {
          this.$toastr.e('Remove', "failed");
        }
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText) , this.list() }
    },
    async save() {
      try {
        if(!(this.model.title || '').trim()) { return this.$toastr.e("title", "require") }
        if(!(this.model.content || '').trim()) { return this.$toastr.e("content", "require") }
        if(!this.model.target_list) { return this.$toastr.e("to", "require") }
        if(!this.model.level) { return this.$toastr.e("level", "require") }

        let model = Object.assign({}, this.model, { target : this.model.target_list });
        delete model.partner;

        // if(model.target && typeof '' == typeof model.target) {
        //   model.target = model.target.split(',');
        // }

        // model.target_code = this.model.target_code.meta.value
        // model.category_code = this.model.category_code.meta.value

        let rs = await Api.Manager_Call('mail', this.model.id ? 'update' : 'insert', model);
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
          if(!this.model.id) { this.refresh(rs.body.id); }
        } else {
          this.$toastr.e('Save', "failed"); this.list();
        }
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }

      this.lock = true;
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created: function() { console.log('mail.detail.vue', 'created'); },
  destroyed: function() { console.log('mail.detail.vue', 'destroyed'); },
  mounted: function() { console.log('mail.detail.vue', 'mounted'); this.get(this.$route.params); },
}
</script>
<style>
.CodeMirror { height: 1000px !important; }
</style>
